export const keyboardShortcutsKeyMap = {
  TOGGLE_NAVBAR: '[',
};
